<div class="PageTitle">
    <h3 style="text-align:left; padding-left: 2%; font-family: Roboto,Arial,sans-serif,Nucleo; color: #004f86;">
        {{corpProfileSetupTitle}}</h3>
</div>
<hr>

<div class="row">
    <div class="col-md-12">
        <mat-card>
            <mat-card-title>
                <div class="PageTitle">
                    <h4
                        style="text-align:left; padding-left: 2%; font-family: Roboto,Arial,sans-serif,Nucleo; color: #004f86;">
                        {{corpProfileSetupTitle}}</h4>
                </div>
            </mat-card-title>

            <!-- content for add -->
            <mat-card-content>
                <br>
                <mat-form-field appearance="outline" style="width: 300px;">
                    <mat-label>Choose Profile</mat-label>
                    <mat-select [formControl]="selectedProfileControl" name="selectedProfile"
                        (selectionChange)="onProfileChange()">
                        <mat-option *ngFor="let selectedProfile of uniqueSelectedProfiles" [value]="selectedProfile">{{
                            selectedProfile.profileNm }}</mat-option>
                    </mat-select>
                </mat-form-field>

                <br>

                <table class="table table-striped table-bordered" *ngIf="selectedProfileControl.value">
                    <thead>
                        <tr>
                            <th>Profile Recipe ID</th>
                            <th>Profile Name</th>
                            <th>IMM</th>
                            <th>Recipe Fold</th>
                            <th>Fold X Coord</th>
                            <th>Fold Y Coord</th>
                            <th>Recipe Roll</th>
                            <th>Roll X Coord</th>
                            <th>Roll Y Coord</th>
                            <th>Rev Dt</th>
                            <th>Rev By</th>
                        </tr>
                    </thead>
                    <tbody>
                        <ng-container *ngFor="let row of selectedProfiles">
                            <tr *ngIf="row.profileNm === selectedProfileControl.value?.profileNm"
                                (click)="onRowClick(row)" [class.selected-row]="selectedRow === row">
                                <td>{{ row.profileRecipeId }}</td>
                                <td>{{ row.profileNm }}</td>
                                <td>{{ row.imm }}</td>
                                <td>{{ row.recipeFold }}</td>
                                <td>{{ row.foldXCoord }}</td>
                                <td>{{ row.foldYCoord }}</td>
                                <td>{{ row.recipeRoll }}</td>
                                <td>{{ row.rollXCoord }}</td>
                                <td>{{ row.rollYCoord }}</td>
                                <td>{{ formatRevDate(row.revDt) }}</td>
                                <td>{{ row.revBy }}</td>
                            </tr>
                        </ng-container>
                    </tbody>
                </table>

                <div class="row">
                    <!-- button row for submit new perf measurements -->
                    <div class="button-row col-md-2" style="padding-top: 10px;" *ngIf="showAddIMMButton">
                        <button class="mr-1" mat-flat-button color="primary" (click)="addImmButton()"
                            [disabled]="addIMMDisable">Add</button>
                    </div>

                    <!-- button row for submitting a modify request -->
                    <div class="button-row col-md-2" style="padding-top: 10px;" *ngIf="showModifyIMMButton">
                        <button class="mr-1" mat-flat-button color="primary" (click)="modifyImmButton()"
                            [disabled]="modifyIMMDisable">Modify</button>
                    </div>

                    <!-- button row for excel upload request -->

                    <div class="file-upload" style="padding-top:10px;">
                        <input type="file" accept=".xlsx" class="file-input" (change)="onFileSelected($event)"
                            #fileUpload>
                        <div style="display:inline-block; white-space: nowrap;">
                            <button (click)="fileUpload.click()" class="mr-1" mat-flat-button
                                color="primary">Upload</button>
                        </div>
                    </div>



                </div>

            </mat-card-content>
        </mat-card>

        <br>
        <br>

        <!-- inputs for profile recipe details -->
        <mat-card *ngIf="showProfileRecipeDetailsCard">
            <mat-card-title>
                <div class="PageTitle">
                    <h4
                        style="text-align:left; padding-left: 2%; font-family: Roboto,Arial,sans-serif,Nucleo; color: #004f86;">
                        {{addOrUpdateImm}}</h4>
                </div>
            </mat-card-title>

            <mat-card-content>
                <br>

                <div class="row">
                    <div class="col-md-1" style="width: 200px; height:100px;">
                        <mat-form-field appearance="outline" class="w-100" style="width: 175px;">
                            <mat-label>Profile Recipe ID</mat-label>
                            <input [formControl]="profileRecipeIdControl" matInput placeholder="Profile Recipe ID"
                                maxlength="10" value="">
                            <mat-error>Invalid Profile Recipe ID</mat-error>
                        </mat-form-field>
                    </div>

                    <div class="col-md-1" style="width: 200px; height:100px;">
                        <mat-form-field appearance="outline" class="w-100" style="width: 175px;">
                            <mat-label>Profile Name</mat-label>
                            <input [formControl]="profileNmControl" matInput placeholder="Profile Name"
                                maxlength="10" value="">
                            <mat-error>Invalid Profile Name</mat-error>
                        </mat-form-field>
                    </div>

                    <div class="col-md-1" style="width: 200px; height:100px;">
                        <mat-form-field appearance="outline" class="w-100" style="width: 175px;">
                            <mat-label>IMM</mat-label>
                            <input [formControl]="immControl" matInput placeholder="IMM" maxlength="10"
                                value="">
                            <mat-error>Invalid IMM</mat-error>
                        </mat-form-field>
                    </div>

                    <div class="col-md-1" style="width: 200px; height:100px;">
                        <mat-form-field appearance="outline" class="w-100" style="width: 175px;">
                            <mat-label>Recipe Fold</mat-label>
                            <input [formControl]="recipeFoldControl" matInput placeholder="Recipe Fold" maxlength="10"
                                value="">
                            <mat-error>Invalid Recipe Fold</mat-error>
                        </mat-form-field>
                    </div>

                    <div class="col-md-1" style="width: 200px; height:100px;">
                        <mat-form-field appearance="outline" class="w-100" style="width: 175px;">
                            <mat-label>Fold X Coord</mat-label>
                            <input [formControl]="foldXCoordControl" matInput placeholder="Fold X Coord"
                                maxlength="10" value="">
                            <mat-error>Invalid Fold X Coord</mat-error>
                        </mat-form-field>
                    </div>

                    <div class="col-md-1" style="width: 200px; height:100px;">
                        <mat-form-field appearance="outline" class="w-100" style="width: 175px;">
                            <mat-label>Fold Y Coord</mat-label>
                            <input [formControl]="foldYCoordControl" matInput placeholder="Fold Y Coord" maxlength="10"
                                value="">
                            <mat-error>Invalid Fold Y Coord</mat-error>
                        </mat-form-field>
                    </div>

                    <div class="col-md-1" style="width: 200px; height:100px;">
                        <mat-form-field appearance="outline" class="w-100" style="width: 175px;">
                            <mat-label>Recipe Roll</mat-label>
                            <input [formControl]="recipeRollControl" matInput placeholder="Recipe Roll" maxlength="10"
                                value="">
                            <mat-error>Invalid Recipe Roll</mat-error>
                        </mat-form-field>
                    </div>

                    <div class="col-md-1" style="width: 200px; height:100px;">
                        <mat-form-field appearance="outline" class="w-100" style="width: 175px;">
                            <mat-label>Roll X Coord</mat-label>
                            <input [formControl]="rollXCoordControl" matInput placeholder="Roll X Coord" maxlength="10"
                                value="">
                            <mat-error>Invalid Roll X Coord</mat-error>
                        </mat-form-field>
                    </div>

                    <div class="col-md-1" style="width: 200px; height:100px;">
                        <mat-form-field appearance="outline" class="w-100" style="width: 175px;">
                            <mat-label>Roll Y Coord</mat-label>
                            <input [formControl]="rollYCoordControl" matInput placeholder="Roll Y Coord" maxlength="10"
                                value="">
                            <mat-error>Invalid Roll Y Coord</mat-error>
                        </mat-form-field>
                    </div>

                </div>

                <div class="row">
                    <!-- button row for submit new perf measurements -->
                    <div class="button-row col-md-2" style="padding-top: 10px;" *ngIf="showAddIMMButton">
                        <button class="mr-1" mat-flat-button color="primary" (click)="saveFormButton()"
                            [disabled]="addIMMDisable">Save</button>
                    </div>

                    <!-- button row for submitting a modify request -->
                    <div class="button-row col-md-2" style="padding-top: 10px;" *ngIf="showModifyIMMButton">
                        <button class="mr-1" mat-flat-button color="primary" (click)="resetForm()"
                            [disabled]="false">Cancel</button>
                    </div>

                </div>
            </mat-card-content>




        </mat-card>

    </div>


</div>